import { TRADING_NAME, WEBSITE_URL } from '@/constants/company';

/** @deprecated OAuth removed — use AuthDialog / AuthContext login instead. */
export const APP_TITLE = TRADING_NAME;

export const GA4_MEASUREMENT_ID = import.meta.env.VITE_GA4_MEASUREMENT_ID ?? '';
export const HOTJAR_ID = Number(import.meta.env.VITE_HOTJAR_ID) || 0;
export const SITE_URL = (import.meta.env.VITE_SITE_URL ?? WEBSITE_URL).replace(/\/$/, '');
